/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { connect } from "react-redux";
import myFav from "../../../../models/myFav";
import { lock } from "hf-rt";

const BLACK_HEART = "addToFav_btn active";
const WHITE_HEART = "addToFav_btn";

class AddToFav extends React.Component {
    // state = {
    //     heart: WHITE_HEART,
    //     isInitial: true,
    //     lock: false
    // };
    // componentDidUpdate() {
    //     if (this.state.isInitial) {
    //         const { pdtId, myFavList } = this.props;

    //         if (!pdtId) return;
    //         if (!myFavList) return;

    //         if (myFavList.find(item => item.id === pdtId)) {
    //             this.setState({
    //                 heart: BLACK_HEART,
    //                 isInitial: false
    //             });
    //         }
    //     }
    // }

    // async handleClick(e) {
    //     const { push, pop, pdtId, fetchMyFav } = this.props;

    //     await this.setState({ lock: true });

    //     if (this.state.heart === WHITE_HEART) {
    //         await this.setState({ heart: BLACK_HEART });
    //         await push(pdtId);
    //     } else {
    //         await this.setState({ heart: WHITE_HEART });
    //         await pop(pdtId);
    //     }
    //     await fetchMyFav();
    //     await this.setState({ lock: false });
    // }
    handleAddWishList = () => {
        const { pdtId, wishListData } = this.props;
        const found = wishListData.wishListItems.findIndex(
            data => data.channelCatalogItemCode === pdtId
        );
        if (found !== -1) {
            // 已在願望清單，移除自己
            this.props.removeFromMyFav(pdtId);
    } else {
            // 不在願望清單，加入自己
            const data = {
                channelCatalogItemCode: pdtId
            };
            this.props.addToMyFav(data);
    }
    };
    isWishList = () => {
        const { pdtId, wishListData } = this.props;
        if (wishListData && pdtId) {
            const found = wishListData.wishListItems.findIndex(
                data => data.channelCatalogItemCode === pdtId
            );
            if (found !== -1) {
                return "active";
            } else {
                return "";
  }
        } else {
            return "";
        }
    };
  render() {
    return (
            // <a
            //     className={this.state.heart}
            //     onClick={e => lock(this.state.lock, this.handleClick(e))}
            // />
      <a
                className={`fav-btn ${this.isWishList()}`}
                onClick={this.handleAddWishList}
            ></a>
    );
  }
}

const mapStateToProps = state => {
  return {
        // myFavList: state.myFav.wishListItems
        wishListData: state.myFav.wishListItems
  };
};
const mapDispatchToProps = () => {
  return {
        addToMyFav: wishItemCode => myFav.actions.addToMyFav(wishItemCode),
        removeFromMyFav: wishItemCode =>
            myFav.actions.removeFromMyFav(wishItemCode)
        // push: pdtId => myFav.actions.addToMyFav(pdtId),
        // pop: pdtId => myFav.actions.removeFromMyFav(pdtId),
        //fetchMyFav: () => myFav.actions.fetchMyFavList()
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddToFav);
